export const NO_SAML_REDIRECT = null;
export const SAML_REDIRECT_PARAM = 'redirectTo';
